// extracted by mini-css-extract-plugin
module.exports = {"community-tools-paragraph":"CommunityTools_community-tools-paragraph__GlILm","community-tools-cards-item":"CommunityTools_community-tools-cards-item__y7M6e"};